// @flow

import * as React from 'react'
import styled, { css } from 'styled-components'

import { addPxToInput, removeNonDigits } from '../../../../shared'
import {
  WebshopGridItemBanner,
  useParsedMediaFile,
  WidgetContainer,
} from '../shared'

const WebshopHeaderBackdrop = ({
  gridItem,
  editedGridItemId,
  outsideProps,
  ...restProps
}) => {
  const { header } = outsideProps || {}
  const isEditingGridItem = editedGridItemId && gridItem.id === editedGridItemId

  const [backdropUrl, backdropVideo, backdropVideoType] = useParsedMediaFile(
    gridItem.data.backdrop
  )

  const contentContainerStyle = React.useMemo(
    () => ({
      height: '100%',
    }),
    []
  )

  return (
    <WebshopGridItemBanner
      backgroundUrl={backdropUrl}
      contentContainerStyle={contentContainerStyle}
      gridItem={gridItem}
      heightMode={gridItem.data.height_mode}
      heightValue={
        {
          viewport_percentage: gridItem.data.viewport_percentage_height,
          fixed: gridItem.data.fixed_height,
        }[gridItem.data.height_mode]
      }
      isEditing={isEditingGridItem}
      videoUrl={backdropVideo}
      videoType={backdropVideoType}
    >
      {header && (
        <HeaderContainer gridItem={gridItem}>{header}</HeaderContainer>
      )}

      <ChildrenContainer gridItem={gridItem}>
        {gridItem.children.map(childGridItem => {
          const GridItemComponent = childGridItem.component

          if (!GridItemComponent) {
            return null
          }

          return (
            <GridItemComponent
              gridItem={childGridItem}
              editedGridItemId={editedGridItemId}
              outsideProps={outsideProps}
              {...restProps}
            />
          )
        })}

        {isEditingGridItem &&
          (backdropUrl || backdropVideo) &&
          gridItem.children.length === 0 && (
            <ChildrenPlaceholder>
              Widgets inside will go here
            </ChildrenPlaceholder>
          )}
      </ChildrenContainer>
    </WebshopGridItemBanner>
  )
}

export default WebshopHeaderBackdrop

const HeaderContainer = styled.div`
  /*
    If the backdrop is using some left or right padding, we need to subtract that
    via negative margin so header can apply its own margin/padding.
  */
  margin-left: ${({ gridItem }) =>
    addPxToInput(-1 * (gridItem.style.paddingLeft || 0))};
  margin-right: ${({ gridItem }) =>
    addPxToInput(-1 * (gridItem.style.paddingRight || 0))};
`

const ChildrenContainer = styled.div`
  position: absolute;

  ${({ gridItem }) => {
    if (gridItem.data.inner_elements_position === 'bottom_left') {
      return css`
        bottom: 0;
        left: 0;
      `
    } else if (gridItem.data.inner_elements_position === 'bottom_center') {
      return css`
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      `
    } else if (gridItem.data.inner_elements_position === 'bottom_right') {
      return css`
        bottom: 0;
        right: 0;
      `
    }
  }};
`

const ChildrenPlaceholder = styled.div`
  font-size: 14px;
  line-height: 1.1;
  color: #777777;
  padding: 15px;
  background-color: rgba(213, 213, 213, 0.8);
`
